<div class="container mx-auto space-y-6">
  <!-- Page Header -->
  <div class="flex flex-wrap items-center justify-between pb-4 border-b border-base-300">
    <div>
      <h1 class="text-2xl font-bold text-base-content">App Management</h1>
      <p class="text-sm text-base-content/60 mt-1">Manage third-party integrations for your instructor account</p>
    </div>
  </div>

  <!-- Zoom Integration Card -->
  <div class="daisy-card bg-base-100 shadow border border-base-200">
    <div class="daisy-card-body">
      <div class="flex items-center gap-3 mb-4">
        <div class="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
          <i class="fa-solid fa-video text-blue-600 text-lg"></i>
        </div>
        <div>
          <h2 class="text-lg font-bold text-base-content">Zoom Integration</h2>
          <p class="text-sm text-base-content/60">Connect your Zoom account to host live classes</p>
        </div>
      </div>

      @if (isPageLoading()) {
        <div class="flex justify-center py-8">
          <span class="daisy-loading daisy-loading-spinner daisy-loading-md text-primary"></span>
        </div>
      } @else {

        @if (!zoomAccount()) {
          <!-- No account linked -->
          <div class="flex flex-col items-center text-center py-8 gap-4">
            <div class="w-16 h-16 rounded-full bg-base-200 flex items-center justify-center">
              <i class="fa-solid fa-link-slash text-base-content/40 text-2xl"></i>
            </div>
            <div>
              <p class="font-semibold text-base-content">No Zoom account connected</p>
              <p class="text-sm text-base-content/60 mt-1">
                Connect your personal Zoom account to create and host meetings directly from your account.
              </p>
            </div>
            <button class="daisy-btn daisy-btn-primary gap-2" (click)="connectZoomAccount()">
              <i class="fa-solid fa-plug"></i>
              Connect Zoom Account
            </button>
          </div>
        } @else if (zoomAccount()?.accountType === 'internal') {
          <!-- Internal account — read only -->
          <div class="daisy-alert daisy-alert-info mb-4">
            <i class="fa-solid fa-circle-info"></i>
            <span>This Zoom account is managed by the platform administrator and cannot be changed here.</span>
          </div>
          <div class="flex items-center justify-between p-4 bg-base-200 rounded-lg">
            <div class="flex items-center gap-3">
              <div class="daisy-avatar daisy-placeholder">
                <div class="bg-info text-info-content rounded-full w-10 h-10 flex items-center justify-center">
                  <i class="fa-solid fa-user text-sm"></i>
                </div>
              </div>
              <div>
                <p class="font-medium text-base-content">{{ zoomAccount()?.username }}</p>
                <div class="flex items-center gap-2 mt-1">
                  <span class="daisy-badge daisy-badge-info daisy-badge-sm">Internal</span>
                  <span class="daisy-badge daisy-badge-success daisy-badge-sm">
                    <i class="fa-solid fa-circle-check mr-1 text-xs"></i>Active
                  </span>
                </div>
              </div>
            </div>
          </div>
        } @else {
          <!-- Public account — can unlink or reconnect -->
          <div class="flex items-center justify-between p-4 bg-base-200 rounded-lg">
            <div class="flex items-center gap-3">
              <div class="daisy-avatar daisy-placeholder">
                <div class="bg-primary text-primary-content rounded-full w-10 h-10 flex items-center justify-center">
                  <i class="fa-solid fa-user text-sm"></i>
                </div>
              </div>
              <div>
                <p class="font-medium text-base-content">{{ zoomAccount()?.username }}</p>
                <div class="flex items-center gap-2 mt-1">
                  <span class="daisy-badge daisy-badge-primary daisy-badge-sm">Public</span>
                  <span class="daisy-badge daisy-badge-success daisy-badge-sm">
                    <i class="fa-solid fa-circle-check mr-1 text-xs"></i>Connected
                  </span>
                </div>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <button
                class="daisy-btn daisy-btn-sm daisy-btn-outline gap-2"
                (click)="connectZoomAccount()"
              >
                <i class="fa-solid fa-rotate"></i>
                Reconnect
              </button>
              <button
                class="daisy-btn daisy-btn-sm daisy-btn-error daisy-btn-outline gap-2"
                [disabled]="isUnlinking()"
                (click)="unlinkZoomAccount()"
              >
                @if (isUnlinking()) {
                  <span class="daisy-loading daisy-loading-spinner daisy-loading-xs"></span>
                } @else {
                  <i class="fa-solid fa-link-slash"></i>
                }
                Unlink
              </button>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
